export enum SystemOsType {
  WINDOWS = 'WINDOWS',
  MACOSX = 'MACOSX',
  LINUX = 'LINUX',
  ANDROID = 5,
  IOS = 6,
  OTHER = 7,
}
